import React, { useEffect, useState } from "react";
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from "../../../lib/axios";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'AccmgrpName', label: 'Group Name', minWidth: 100 },
  { id: 'AccmgrpAbvr', label: 'Abbreviation', minWidth: 100 },
  { id: 'SeqNo', label: 'SeqNo', minWidth: 100 }
];

const MainGroup = () => {
  const [formData, setFormData] = useState({
    accmgrpName: '',
    accmgrpAbvr: ''
  });

  const [error, setError] = useState({
    accmgrpName: false,
    accmgrpAbvr: false
  });

  const navigate = useNavigate();
  const location = useLocation();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [currentAccmgrpId, setCurrentAccmgrpId] = useState(null);
  const [mode, setMode] = useState('view');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId] = useState(sessionStorage.getItem('UserId') || "1");
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const nameRef = useRef(null);
  const abvrRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.AccmgrpId) {
      setCurrentAccmgrpId(location.state.AccmgrpId);
      fetchGroupData(location.state.AccmgrpId, "R");
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  // fetching or Retrieving the data
  const fetchGroupData = async (id, flag) => {
    try {
      const response = await axiosInstance.post("AccmGrp/RetriveAccmGrp", {
        AccmgrpId: parseInt(id),
        Flag: flag,
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const groupData = Array.isArray(response.data.Data)
          ? response.data.Data[0]
          : response.data.Data;
        if (groupData) {
          const accmgrpName = groupData.accmgrpName || groupData.AccmgrpName || "";
          const accmgrpAbvr = groupData.accmgrpAbvr || groupData.AccmgrpAbvr || "";

          setFormData({
            accmgrpName: accmgrpName,
            accmgrpAbvr: accmgrpAbvr,
          });
          setStatus(groupData.Status?.toString() || "0");
          setIsFormDisabled(true);
          setCurrentAccmgrpId(groupData.AccmgrpId);
          setMode("view");
        } else {
          toast.info("No group data found in response");
          resetForm();
        }
      } else {
        toast.info(response.data.Message || "No group data found for the given ID");
        resetForm();
      }
    } catch (error) {
      toast.error("Error fetching group data");
    }
  };

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post("AccmGrp/GetAccmGrpDashBoard", {
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          setRows([]);
          setDataForPrint({});
        }
      } catch (err) {
        toast.error("Error fetching dashboard data");
      }
    };
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentAccmgrpId && currentAccmgrpId > 1) {
      await fetchGroupData(currentAccmgrpId, "P");
    }
  };

  const handleNext = async () => {
    if (currentAccmgrpId) {
      await fetchGroupData(currentAccmgrpId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setError(prev => ({ ...prev, [name]: !value }));
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === nameRef.current) {
        abvrRef.current.focus();
      } else {
        handleSave();
      }
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  // Submit Button Code Here
  const handleSave = async () => {
    let hasError = false;

    if (!formData.accmgrpName) {
      setError(prev => ({ ...prev, accmgrpName: true }));
      toast.error("Group Name is required");
      hasError = true;
    }
    if (!formData.accmgrpAbvr) {
      setError(prev => ({ ...prev, accmgrpAbvr: true }));
      toast.error("Abbreviation is required");
      hasError = true;
    }

    if (hasError) return;

    try {
      const payload = {
        AccmgrpName: formData.accmgrpName,
        AccmgrpAbvr: formData.accmgrpAbvr,
        Status: Status,
        seqNo: "001",
        lockSt: "N",
        lockId: null,
        CreatedBy: parseInt(UserId),
      };

      let response;
      if (mode === "edit") {
        payload.AccmgrpId = currentAccmgrpId;
        payload.UpdatedBy = parseInt(UserId);
        response = await axiosInstance.post("AccmGrp/UpdateAccmGrp", payload);
      } else {
        response = await axiosInstance.post("AccmGrp/InsertAccmGrp", payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message || "Group saved successfully");
        const newId = response.data.Data?.AccmgrpId || response.data.Data || currentAccmgrpId;
        if (newId) {
          await fetchGroupData(newId, "L");
          setCurrentAccmgrpId(newId);
          setMode("view");
          setIsFormDisabled(true);
        } else {
          toast.error("No ID returned from save operation");
        }
      } else {
        toast.error(response.data.Message || "Failed to save group");
      }
    } catch (error) {
      console.error("Error saving/updating group:", error);
      toast.error("Error saving/updating group");
    }
  };

  // Edit the fetched record
  const handleEdit = async () => {
    if (!currentAccmgrpId) {
      toast.error("No record selected to edit");
      return;
    }
    let Flag = await checkAndLock(currentAccmgrpId, "AccmGrp", "AccmgrpId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        setTimeout(() => nameRef.current.focus(), 0);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    resetForm();
    setTimeout(() => nameRef.current.focus(), 0);
  };

  const handleCancel = async () => {
    try {
      await fetchGroupData(currentAccmgrpId, "L");
      await UnLock(currentAccmgrpId, "AccmGrp", "AccmgrpId");
      setMode('view');
      setIsFormDisabled(true);
    }
    catch (error) {
      console.error("Error during cancel:", error);
      toast.error("Error occurred while cancelling");
    }
  };

  const resetForm = () => {
    setFormData({
      accmgrpName: '',
      accmgrpAbvr: ''
    });
    setStatus("1");
    setCurrentAccmgrpId(null);
    setError({ accmgrpName: false, accmgrpAbvr: false });
  };

  const handleExit = () => {
    navigate('/maingrptable')
  };

  const handleDeleteClick = () => {
    if (currentAccmgrpId) {
      setOpenConfirmDialog(true);
    } else {
      toast.error("No record selected to delete");
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await fetchGroupData(currentAccmgrpId, "D");
      await fetchGroupData(currentAccmgrpId, "N");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error deleting . Please try again.');
    }
    setOpenConfirmDialog(false);
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentAccmgrpId || currentAccmgrpId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentAccmgrpId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Main Group Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Main Group"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="accmgrpName"
                  name="accmgrpName"
                  label={
                    <span>
                      Group Name <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.accmgrpName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.accmgrpName}
                  helperText={error.accmgrpName && ""}
                  inputRef={nameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="accmgrpAbvr"
                  name="accmgrpAbvr"
                  label={
                    <span>
                      Abbreviation <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.accmgrpAbvr}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.accmgrpAbvr}
                  helperText={error.accmgrpAbvr && ""}
                  inputRef={abvrRef}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Main Group Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />}
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MainGroup;